import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReportApiService {
  constructor(private http: HttpClient) {}

  genReport(type: string, data: any) {
    return lastValueFrom(
      this.http.post(`/report/getReport/${type}`, data, {
        responseType: 'blob',
      })
    );
  }
  exportReport(type: string, data: any) {
    return lastValueFrom(
      this.http.post(`exportTemplate/${type}`, data, {
        responseType: 'blob',
      })
    );
  }
  exportExcel(data: any) {
    return lastValueFrom(
      this.http.post(`/exportExcel`, data, {
        responseType: 'blob',
      })
    );
  }
  getTemplateByCode(code){
      return lastValueFrom(
      this.http.get(`/export/getTemplateByCode/${code}`)
    );
  }
}
